import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./userSlice";
import iomPendingCount from "./IOMPendingCount";
import userFeaturesReducer from "./userFeatureSlice";
import featureMenuReducer from "./featureMenuSlice";
import companyReducer from "./companySlice";

export const store = configureStore({
    reducer: {
        user: userReducer,
        company: companyReducer,
        iomPendingCount: iomPendingCount,
        userFeatures: userFeaturesReducer,
        featureMenu: featureMenuReducer,
    },
});
